<template>
  <div>

    <memlist-card v-if="invalid_link">
      <memlist-inline-alert style="min-width: 480px;" variant="danger">Ogiltig länk.</memlist-inline-alert>
    </memlist-card>

    <memlist-card v-else style="width: 480px;">

      <h4 class="text-center" v-if="mfa === 'sms'">En kod har skickats till ditt kopplade telefonnummer.</h4>
      <h4 class="text-center" v-if="mfa === 'email'">En kod har skickats till din kopplade e-postadress. Kontrollera din inkorg.</h4>

      <memlist-text-input
        class="mt-16"
        :title="'Ange kod'"
        v-model="code"
        size="lg"
        @input="code_input"

        v-if="!checking"
      />

      <div v-if="checking" class="d-flex justify-content-center mb-8 mt-8">
        <memlist-spinner />
      </div>
      
      <memlist-inline-alert v-if="error" variant="danger">Ogiltig kod, försök igen om 1 minut.</memlist-inline-alert>

    </memlist-card>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import { LOGIN } from '@/core/services/store/auth.module';
import { SET_COMPANY_ID } from '@/core/services/store/common.module';
import { SET_ULOGIN_LINK } from '@/core/services/store/auth.module';

import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { setKeyValue, getKeyValue } from '@/core/services/simpleStore';

export default {
  mixins: [ validationMixin, toasts ],
  name: 'MFA',
  components: {
    
  },

  data() {
    return {
      uuid: null,
      mfa: null,
      token: null,
      code: null,
      checking: false,
      error: false,
      invalid_link: false,

    };
  },
 
  async mounted() {
    this.uuid = this.$route.params.uuid;
    this.token = this.$route.params.token;
    this.mfa = this.$route.params.mfa;

    if (!this.uuid || !this.token || !this.mfa) {
      this.invalid_link = true;
    }
  },
  methods: {

    async code_input() {
      if (this.code.length === 6) {
        this.checking = true;
        await this.post_mfa_code();
      }
    },

    async post_mfa_code() {
      const res = await axios.post(`/user/mfa/code`, {
        uuid: this.uuid,
        token: this.token,
        code: this.code
      });

      if (res.status === 200) {
        const data = res.data;
        
        if (data.selected_company_id) {
          this.$store.dispatch(SET_COMPANY_ID, data.selected_company_id);
        }

        this.$store.dispatch(LOGIN, {
          user: {
            user_id: data.id,
            email: data.name
          },
          token: data.token,
          refresh_token: data.refresh_token.refresh_token,
          expires_ts: data.refresh_token.expires_ts
        });

        this.$router.push({ name: 'ml-auth-forward' });
      }
      else {
        this.checking = false;
        this.error = true;
      }
    },


    async get_public_data() {
      try {
        const res = await axios.get(`/company/public-data`);

        if (res.status === 200) {
          return res.data;
        }

      }
      catch (err) {
        console.error('get_public_data', err);
      }

      return null;
    },


  },
  computed: {
    
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>

